export default __webpack_public_path__ + "static/media/320.58c483c3.png";